// extracted by mini-css-extract-plugin
export default {"labelText":"Label_labelText__xGPSp","onTopLabel":"Label_onTopLabel__r8z8-"};